import { fromNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableModel } from '../../models/ValuableModel'

export class SchemaStringModel extends ValuableModel {
  @fromNode()
  @reactive()
  format?: string

  @fromNode()
  @reactive()
  maxLength?: number

  @fromNode()
  @reactive()
  minLength?: number

  @fromNode()
  @reactive()
  pattern?: string
}

declare global {
  export interface RehajeViewModels {
    'Schema.String': SchemaStringModel
  }
}
